export default __webpack_public_path__ + "static/media/2.86cadb35.jpg";